Kuraidesu, [16.03.21 09:47]
<template>
  <div class="sticky-top">
    <div class="header">
      <b-container>
        <b-navbar toggleable="lg">
          <b-navbar-brand href="/" class="logo text-success">
            <b-img src="@/assets/images/header.png" height="80" width="auto" alt="" srcset="" />
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class=" ml-auto text-uppercase menu text-white">
              <b-nav-item to="/"><span class="font-weight-bold item"> Accueil</span></b-nav-item>
              <b-nav-item to="/about-us"><span class="font-weight-bold item">La SOBEMAP</span></b-nav-item>
              <b-nav-item to="/resources"><span class="font-weight-bold item">Moyens techniques</span></b-nav-item>
              <b-nav-item to="/prestations"><span class="font-weight-bold item">Prestations</span></b-nav-item>
              <b-nav-item to="/actualites"><span class="font-weight-bold item">Actualités</span></b-nav-item>
              <b-nav-item to="/contact"><span class="font-weight-bold item">Contacts</span></b-nav-item>
              <b-nav-item class="heartbeat" @click="handleInfoModal"><b-icon-bell-fill scale="1.2" class="text-success"></b-icon-bell-fill></b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-container>
    </div>
    <b-modal
      v-model="showInfoModal"
      :visible="showInfoModal"
      title="Communiqué"
      centered
    >
      <div>
        <b-img src="@/assets/images/header.png" height="100" width="auto" alt="" srcset="" class="mb-3" />

        <p>La Direction de la <strong>SOBEMAP</strong> passe par le présent communiqué pour rassurer son aimable clientèle (Importateurs et leurs mandataires) de ce que leurs marchandises sont en sécurité lors des opérations de manutention, sur ses terre-pleins et dans ses magasins.</p>
        <p>Elle vous remercie de votre confiance et se tient à votre disposition pour toutes vos préoccupations éventuelles.</p>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="success"
            size="sm"
            class="float-right"
            @click="handleInfoModal"
          >
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovered: false,
      showInfoModal: false,
    }
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered
    },
    handleInfoModal() {
      this.showInfoModal = !this.showInfoModal
    }
  }
}
</script>

<style lang="scss">
.header {
  border-radius: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(40deg, rgba(255, 255, 255, 1) 46%, #21a862 100%);
}

.navbar-light .navbar-toggler {
  border-color: transparent;
}

.exact-active .item {
  text-decoration-style: solid;
  border-bottom: 2px solid #006435;
  line-height: 50px;
  cursor: pointer;
}

.menu .item {
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 18px;
  color: #006435;
  /* identical to box height, or 20px */
}

.heartbeat{-webkit-animation:heartbeat 1.5s ease-in-out infinite both;animation:heartbeat 1.5s ease-in-out infinite both}

.denomination {
  width: 30%;
  font-weight: 900;
}

/* ----------------------------------------------
 * Generated by Animista on 2023-2-19 13:35:24
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

 @-webkit-keyframes heartbeat{from{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}10%{-webkit-transform:scale(.91);transform:scale(.91);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}17%{-webkit-transform:scale(.98);transform:scale(.98);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}33%{-webkit-transform:scale(.87);transform:scale(.87);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}45%{-webkit-transform:scale(1);transform:scale(1);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}}@keyframes heartbeat{from{-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:center center;transform-origin:center center;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}10%{-webkit-transform:scale(.91);transform:scale(.91);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}17%{-webkit-transform:scale(.98);transform:scale(.98);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}33%{-webkit-transform:scale(.87);transform:scale(.87);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}45%{-webkit-transform:scale(1);transform:scale(1);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}}
</style>